export default __webpack_public_path__ + "static/media/test2.87f584c9.png";